import React from 'react';
import cn from 'classnames';

import defaultImg from '../../../../assets/image/newShop/defaultImg.png';
import CustomBadge from '../../../../components/mazraeKit/customBadge';
import {addDotTostring} from '../../../../utilities/helper/textConvertor';
import {toast} from 'react-toastify';

interface IAccordionLikeProps {
  logo?: string;
  title: string;
  active: boolean;
  activeInput?: IInputsFilter;
  onClick?: () => void;
  onRemoveItem?: () => void;
  disable?: boolean;
}

const AccardionLike = ({
  logo,
  title,
  active,
  activeInput,
  onClick,
  onRemoveItem,
  disable = false,
}: IAccordionLikeProps) => {
  const disabledClickHandler = () => {
    toast.error(
      'پکیج فعال فروشگاه شما امکان انتشار آگهی در این موضوع را ندارد',
    );
  };
  return (
    <div
      className={cn('flex justify-between items-center px-2 py-1 border-b', {
        'bg-farm-shop-50': active,
        'bg-gray-50 opacity-50': disable,
      })}
      onClick={!disable ? onClick : disabledClickHandler}
    >
      <div className="flex gap-2 justify-between items-center">
        <img
          className={cn(
            'object-content w-14 h-14 transition-all',
            disable && 'grayscale',
          )}
          alt=""
          src={logo || defaultImg}
        />
        <span className="text-gray-900">{title}</span>
      </div>
      <div className="flex gap-2 items-center">
        {activeInput?.title && (
          <CustomBadge
            title={addDotTostring(activeInput?.title, 9)}
            onRemoveItem={onRemoveItem}
            disable={disable}
            textColor={'!text-farm-shop-800'}
          />
        )}
        <i
          className={cn('icon-nameArrow---Down-2-1', {
            'text-gray-400': active,
            'text-gray-700': !active,
          })}
        />
      </div>
    </div>
  );
};

export default AccardionLike;
